export default "__VITE_ASSET__63a13450__"